import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { useSaleTypesAsArray } from 'app/dataProviders/SaleTypesData'

import styles from './EditTypeModal.module.scss'
import { useState } from 'react'
import usePopup from 'app/common/hooks/usePopup'

export const EditTypeModal = ({
  itemsSelected,
  onClose,
}: {
  itemsSelected: Array<{ id: string; title: string }>
  onClose: () => void
}) => {
  const { saleTypes, loading } = useSaleTypesAsArray()
  const [selected, setSelected] = useState<Array<string>>([])
  const [submitting, setSubmitting] = useState(false)

  const popup = usePopup()

  const handleSubmit = async () => {
    const [targetId] = selected
    if (targetId) {
      setSubmitting(true)
      console.log(targetId)
      popup('Пока эта функция не реализована, но спасибо за старание :)')
      setSubmitting(false)
      onClose()
    }
    return false
  }

  return (
    <PlainModal show formId="change_type" onSubmit={handleSubmit}>
      <PlainModalHeader onCrossClick={onClose}>{'Редактирование типа продукции'}</PlainModalHeader>
      <PlainModalContent>
        <p>По следующим позициям будет изменен тип продукции</p>
        <ul>
          {itemsSelected.map(({ id, title }) => (
            <li key={id}>{title}</li>
          ))}
        </ul>
      </PlainModalContent>
      <PlainModalFooter className={styles.selectorFooter}>
        <PlainItemsSelector
          id="dishType"
          label="Выбор нового типа продукции"
          header="Выберите тип продукции"
          items={saleTypes}
          onChange={setSelected}
          multiple={false}
          doOnBadgeCrossClick="open"
          selectedAllOnEmptySelection={false}
          loading={loading}
          disableAutoSelect
          skipUpperSpace
          hideButtonReset
        />
      </PlainModalFooter>
      <PlainModalFooter>
        <ControlsBar right>
          <PlainButton onClick={onClose} outline>
            {'Отмена'}
          </PlainButton>
          <PlainButton type="submit" disabled={!selected.length || loading || submitting}>
            {submitting ? 'Применение...' : 'Применить'}
          </PlainButton>
        </ControlsBar>
      </PlainModalFooter>
    </PlainModal>
  )
}
